export default __webpack_public_path__ + "static/media/emotionDecH4.c2f66852.png";